class FeatureHotspotElement extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('.feature-hotspot__trigger');
    this.dialog = this.querySelector('.feature-hotspot-dialog');
    this.closeButton = this.querySelector('.feature-hotspot-dialog__close');
    if (!this.trigger || !this.dialog) return;

    this.trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.dialog.open ? this.close() : this.open();
    });

    if (this.closeButton) {
      this.closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.close();
      });
    }

    this._onDocumentClick = (event) => {
      if (!this.dialog.open) return;
      if (!this.contains(event.target)) this.close();
    };

    this._onKeydown = (event) => {
      if (event.key === 'Escape' && this.dialog.open) this.close();
    };
  }

  open() {
    this.#placeDialog();
    this.dialog.show();
    document.addEventListener('click', this._onDocumentClick);
    document.addEventListener('keydown', this._onKeydown);
  }

  close() {
    this.dialog.close();
    this.dialog.removeAttribute('data-placement');
    document.removeEventListener('click', this._onDocumentClick);
    document.removeEventListener('keydown', this._onKeydown);
  }

  #placeDialog() {
    const container = this.closest('.feature-hotspots__overlay');
    if (!container) return;

    const containerRect = container.getBoundingClientRect();
    const triggerRect = this.trigger.getBoundingClientRect();
    const GAP = 10;

    this.dialog.style.visibility = 'hidden';
    this.dialog.style.display = 'block';
    this.dialog.removeAttribute('data-placement');
    const dialogRect = this.dialog.getBoundingClientRect();
    this.dialog.style.removeProperty('display');
    this.dialog.style.removeProperty('visibility');

    const buttonLeft = triggerRect.left - containerRect.left;
    const buttonRight = triggerRect.right - containerRect.left;
    const buttonBottom = triggerRect.bottom - containerRect.top;

    let x = 'right';
    if (containerRect.width - buttonRight - GAP >= dialogRect.width + GAP) {
      x = 'right';
    } else if (buttonLeft - GAP >= dialogRect.width + GAP) {
      x = 'left';
    } else {
      x = 'center';
    }

    let y = 'bottom';
    if (buttonBottom + dialogRect.height + GAP > containerRect.height) {
      y = 'top';
    }

    this.dialog.setAttribute('data-placement', x + ',' + y);
  }
}

customElements.define('feature-hotspot', FeatureHotspotElement);
